import { Moon, Sun, Monitor, Check } from 'lucide-react';
import { useTheme } from 'next-themes';
import { useTranslation } from 'react-i18next';
import { Button } from './ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';

// MF-245 — plain light / dark / system switch via next-themes. The MF-111 preset
// themes (sepia, solarized, high-contrast, midnight) + accent color were removed
// because switching them flickered/jumped; only the base light/dark base remains.
const OPTIONS = [
  { key: 'light', icon: Sun, labelKey: 'theme.light' },
  { key: 'dark', icon: Moon, labelKey: 'theme.dark' },
  { key: 'system', icon: Monitor, labelKey: 'theme.system' },
] as const;

function iconFor(theme: string | undefined) {
  return theme === 'light' ? Sun : theme === 'dark' ? Moon : Monitor;
}

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const { t } = useTranslation();
  const TriggerIcon = iconFor(theme);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="h-9 w-9">
          <TriggerIcon className="h-[1.2rem] w-[1.2rem]" />
          <span className="sr-only">{t('theme.toggle')}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-auto min-w-max">
        {OPTIONS.map((opt) => {
          const Icon = opt.icon;
          return (
            <DropdownMenuItem
              key={opt.key}
              onClick={() => setTheme(opt.key)}
              className="flex items-center justify-between"
            >
              <div className="flex items-center">
                <Icon className="mr-2 h-4 w-4" />
                <span>{t(opt.labelKey)}</span>
              </div>
              {theme === opt.key && <Check className="h-4 w-4 ml-2" />}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
